import React, { useState, useEffect } from 'react';
import {
  Container,
  Input,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncaissementReduxProps, IEncaissementsReplacementTable } from '../../types/interfaces';
import EncaissementScanModal from '../encaissement_list/EncaissementScanModal';

import { getFtpCheck } from '../../flux/actions/encaissementActions';
import TableContainer from "../tables_manager/TableContainer"
import RepSwitchCell from '../tables_manager/RepSwitchCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt, faFileInvoice, faMoneyCheck } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";

import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Loading from '../Loading';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import PDFLink from '../pdf/PDFLink';
import { E_ERROR } from '../../types/errors';
import { getEncModeRegl, getEncStatut } from "../../services/misc";

const EncaissementListTable = ({ 
  encaissementsData,
  setTableData,
  clearFilters,
  setClearFilters
 }: IEncaissementsReplacementTable) => {
  const history = useHistory();
  const alert = useAlert();
  const skipResetRef = React.useRef(false);
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');

  const columns = [
    {
      Header: "À Récupérer",
      accessor: "replaced",
      Cell: RepSwitchCell,
      className: "text-center",
      disableFilters: true,
    },
    {
      Header: "À Attacher",
      accessor: "replacer",
      Cell: RepSwitchCell,
      className: "text-center",
      disableFilters: true,
    },
    {
      Header: "Aperçus",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
          <div className="actionsContainer">
              {original.recto_name ||original.verso_name || original.URL || original.URL_VERSO ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                onClick={() => (setModalEncaissement(original), setModal(true))}
                title="Aperçu des Scans">
                <FontAwesomeIcon icon={faMoneyCheck} />
              </button> : null}
              {original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map((e, key) => e?.contrat ? <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(e.contrat.id || -1)}
                download={false}
                buttonText=""
                iconSize="inherit"
                // customClassNames="btn btn-info"
                customButtonIcon={faFileInvoice}
                allowPrintPreview={true}
                htmlKey={key}
                htmlTitle={`Voir la fiche de Vente - Dossier N° ${e.contrat.NUM_DOSS}`}
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} /> : null) || null}
          </div>
      ),
    },
    {
      Header: "ID Système",
      accessor: "id",
      hidden: true
    },
    {
      Header: "Projet",
      id: "Projet",
      accessor: (row, index) => row.societe?.LIBELE || row.PROJET || "",
      customExportDisplay: `($.societe && $.societe.LIBELE ? $.societe.LIBELE : undefined) || $.PROJET || ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value, row: {original} }) => value || "-"
    },
    {
      Header: "N° Doss.",
      accessor: "NUM_DOSS",
      filter: (rows, id, e) => rows.filter(t => (t.original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-") || []).includes(e)),
      customExportDisplay: `($.contrat_encaissements && $.contrat_encaissements.length) ? $.contrat_encaissements.filter((e, index, self) => self.findIndex(t => (t.contrat ? t.contrat.id : undefined) === (e.contrat ? e.contrat.id : undefined)) === index).map(t => t.contrat && t.contrat.NUM_DOSS ? t.contrat.NUM_DOSS : "-").join(" / ") : "-"`,
      // Cell: ({ row: {original} }) => original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-").join(" et ") : "-"
      Cell: ({ row: {original} }) => {
        return (<div style={{display: "inline-block"}}>{original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(t => <a href={t.contrat?.id !== null && t.contrat?.id !== undefined ? (`/consultation/${t.contrat.id}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(t.contrat?.id !== null && t.contrat?.id !== undefined)
            window.open('/consultation/' + t.contrat.id,'_blank')
          else
            alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
        }}><button className="openLinkBtn">{t.contrat?.NUM_DOSS || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>) : "-"}</div>)
      }
    },
    {
      Header: "Tiré par",
      accessor: "TIRE_PAR",
      Cell: ({ row: {original} }) => original.TIRE_PAR || "-"
    },
    {
      Header: "Mode de règlement",
      id: "Mode de règlement",
      accessor: (row, index) => getEncModeRegl(row.MODE_REGL),
      customExportDisplay: `getEncModeReglHandle($.MODE_REGL)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Réf. Règlement",
      accessor: "REF_REGLEMENT",
      Cell: ({ row: {original} }) => original.REF_REGLEMENT || "-"
    },
    {
      Header: "Montant encaissé",
      accessor: "MONTANT",
      filter: 'equals',
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Banque",
      accessor: "BANQUE",
      Cell: ({ row: {original} }) => original.BANQUE || "-"
    },
    {
      Header: "Date Encaissement",
      accessor: "DATE_REGLEMENT",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.DATE_REGLEMENT ? new Date($.DATE_REGLEMENT) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Date de CHQ/VAL",
      accessor: "DATE_PORTEFEUILLE",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.DATE_PORTEFEUILLE ? new Date($.DATE_PORTEFEUILLE) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    },
    {
      Header: "Saisie le",
      accessor: "createdAt",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.createdAt ? new Date($.createdAt) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Statut",
      id: "STATUT",
      accessor: row => getEncStatut(row.STATUT),
      customExportDisplay: `getEncStatutHandle($.STATUT)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => value || "-"
    },
    // {
    //   Header: "Statut",
    //   accessor: "STATUT",
    //   Cell: ({ value }) => value ? <div style={value !== "PTF" ? {color: "darkred"} : {}}>{value}</div> : "-",
    // },
    {
      Header: "Réceptionné le",
      accessor: "date_reception",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.date_reception ? new Date($.date_reception) : ""`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    },
    {
      Header: "Réceptionné par",
      accessor: "statut_ptf_bv_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Versé le",
      accessor: "date_verse",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.date_verse ? new Date($.date_verse) : ""`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    },
    {
      Header: "Versé par",
      accessor: "statut_ptf_siege_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Récupéré le",
      accessor: "statut_recupere_saisie_date",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.statut_recupere_saisie_date ? new Date($.statut_recupere_saisie_date) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Récupéré par",
      accessor: "statut_recupere_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Banque versement",
      accessor: "BANQUE_VERSEMENT",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Ancien",
      id: "Ancien",
      accessor: (row, index) => row.is_old === 1 ? "Oui" : "Non",
      customExportDisplay: `$.is_old == 1 ? "Oui" : "Non"`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Observation",
      accessor: "OBSERVATION",
      Cell: ({ value }) => value || "-",
      hidden: true
    }
  ];

  const updateMyData = (rowIndex, columnId, value) => {
    // setSkipPageReset(true);
    skipResetRef.current = true;
    setTableData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }

  React.useEffect(() => {
    // setSkipPageReset(false);
    skipResetRef.current = false;
  }, [encaissementsData])

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={encaissementsData} dataName="encaissements_a_modifier" enableCheckBox={false} clearFilters={clearFilters} setClearFilters={setClearFilters} isEditable={true} updateMyData={updateMyData} skipPageReset={skipResetRef.current} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <EncaissementScanModal modal={modal} setModal={setModal} modalEncaissement={modalEncaissement} setModalEncaissement={setModalEncaissement} />
    </div>
  );
};

const mapStateToProps = (state: IEncaissementReduxProps) => ({
  encaissement: state.encaissement,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(EncaissementListTable);
